class NowPlaying {
  constructor(data) {
    this.title = data.title;
    this.image = data.image;
    this.audio = data.audio;
  }
}

export default NowPlaying;